export const replace_value = {
  methods: {
    replaceValueWithInput(value, check) {
      if (check.includes('digital_signature')) {
        return this.replaceValueWithButton(value, check);
      } else if (check.includes('date_input')) {
        return this.replaceValueDataInput(value, check);
      } else if (check.includes('radio_input')) {
        return this.replaceValueRadioInput(value, check);
      } else if (/<[a-z][\s\S]*>/i.test(value)) {
        return `<input type="hidden" name="${check}" value='${value}' class="js-copy-value consent-variable-values" />${value}`;
      } else {
        return `<input type="text" name="${check}" value='${value}' class="js-copy-value consent-variable-values" />`;
      }
    },
    replaceValueDataInput(value, check) {
      if (value)
        return `<input type="text" name="${check}" value='${moment(value).format('DD/MM/YYYY')}' class="js-copy-value consent-variable-values"/>`;
      else return `<input type="date" name="${check}" value='${value}' class="js-copy-value consent-variable-values"/>`;
    },
    replaceValueRadioInput(value, check) {
      let radioValue = check.split('.')[1];
      let splitted_string = radioValue.split('-');
      if (splitted_string && splitted_string[0] && new RegExp(/^[a-zA-Z0-9]+$/).test(splitted_string[0]))
        return `<input type="radio" name="${splitted_string[0]}" id="${check}" class="js-copy-value consent-variable-values" ${value ? 'checked' : ''} />`;
      else return '';
    },
  },
};

export const digital_signature = {
  data() {
    return {
      isWacomSignaturePresent: false,
      wacomSignatureCount: 0,
      wacomSignature: [],
    };
  },
  methods: {
    replaceValueWithButton(value, check) {
      let splitCheck = check.split('.');
      if (splitCheck[0] == 'digital_signature' && new RegExp(/^[a-zA-Z0-9]+$/).test(splitCheck[1])) {
        this.isWacomSignaturePresent = true;
        this.wacomSignatureCount += 1;
        let elementId = splitCheck[1];
        if (value) return `<img style="height: 50px; width: auto;" class="${elementId}" src="${value?.src || value}" />`;
        else
          return `<button class="btn btn-primary digital_signature" style="font-size: 12px; padding: 2px 5px;" id="${elementId}">Aggiungi firma</button><img style="height: 50px; width: auto;" class="image-${elementId}" />`;
      } else {
        ('');
      }
    },
  },
};

const consent_variables = {
  methods: {
    async CV_setVariables(results) {
      const { hasHeader, hasFooter, translates } = results;
      let index = 0;
      if (hasHeader) {
        this.consent.consent_template = { ...this.consent.consent_template, header: translates[0] };
        index++;
      }
      const { consent_template } = this.consent;
      if (consent_template?.sections) {
        this.consent.consent_template.sections = consent_template.sections?.map((section, i) => {
          return { ...section, text: translates[index + i] };
        });
      }
      if (hasFooter) {
        this.consent.consent_template = { ...this.consent.consent_template, footer: translates[translates.length - 1] };
      }
    },
    async CV_resolveVariables(requirements, variables) {
      let header = this.consent?.consent_template?.header,
        sectionsText = this.consent?.consent_template?.sections?.map((section) => section.text),
        footer = this.consent?.consent_template?.footer,
        allTexts = [header, ...sectionsText, footer];
      let translates = await this.PU_translateVariablesAndResolve(
        variables,
        allTexts.filter((text) => text),
        requirements,
        this.guest_period_data_set_id,
        requirements,
        true,
        false,
        this.replaceValueWithInput,
      );
      return {
        translates,
        hasHeader: !!header,
        hasFooter: !!footer,
      };
    },
  },
};

export { consent_variables };
